"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _scrollbar = _interopRequireDefault(require("./scrollbar"));

var _default = _scrollbar.default;
exports.default = _default;